import { utilityServiceUrl } from "../../../../libs/menu-shared/src/environments/default-menu.config";
// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
const environment = {
    production: false,
    //fourSureApiUrl: "http://localhost:5000/4sure",
    fourSureApiUrl: `${utilityServiceUrl}/4sure`,
    analytics: {
        enabled: true,
        defaults: {
            component_name: "Installation",
            journey_name: "Track Installation"
        }
    }
};

export default environment;